export default __webpack_public_path__ + "static/media/pragmatic.3c2aa6db.svg";